<!-- 没数据展示 -->
<template>
  <div 
    class="base-empty" 
    :class="{ 'is-error': isError }"
    :style="{ width }"
  >
    <span class="base-empty__tips">
      {{ text }}
    </span>
    <BaseButton 
      plain 
      round 
      class="base-empty__btn"
      @click="$emit('btnClick')"
    >
      {{ btnText }}
    </BaseButton>
  </div>
</template>

<script>

export default {
  name: 'BaseEmpty',
  props: {
    width: {
      type: String,
      default: '400px'
    },
    text: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.base-empty {
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  padding-left: 11px;
  border-radius: 3px;
  background-color: #FEF5E4;
  &.is-error {
    background-color: #FEF0F0;
    .base-empty__tips {
      color: #999999;
    }
    .base-empty__btn {
      color: $--color-danger;
      border-color: $--color-danger;
    }
  }
  .base-empty__tips {
    font-size: 13px;
    color: #C08534;
  }
  .base-empty__btn {
    display: flex;
    align-items: center;
    margin-left: 15px;
    padding: 0 12px;
    height: 24px;
  }
}
</style>